// extracted by mini-css-extract-plugin
module.exports = {"listName":"_2YTN2paL0fh03na4qkOEHI","heading":"_3HghBC5qAeEx2URWj4zlIT","ingress":"_2oTZWuxuhFlKHexv5dQY8_"};